import { useIntl } from "react-intl";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "src/app/utils/AssetHelpers";

import {} from "src/app/types/planning";
import { useApiStatus } from "src/app/hooks";
import { IApiStatus } from "src/app/types/ApiCredential";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Pacman from "src/app/components/layout/Pacman";

const ApiStatusContainer = () => {
    const { formatMessage } = useIntl();
    const { apiStatus, loading } = useApiStatus();

    if (loading) {
        return <Pacman />;
    }
    if (!apiStatus) {
        return <></>;
    }

    return (
        <div className="apiStatusWrapper">
            {Object.keys(apiStatus).map((api, index) => {
                const currentApiStatus = apiStatus[api as keyof IApiStatus];
                const tooltip = <Tooltip id="tooltip">{currentApiStatus.error}</Tooltip>;

                return (
                    <div key={index} className="informationWrapper">
                        <span className="infor">
                            {currentApiStatus.ok ? (
                                <>
                                    {typeof currentApiStatus.balance === "string" ||
                                    currentApiStatus.balance > 0 ||
                                    currentApiStatus.balance === null ? (
                                        <SVG
                                            className="pulse-animation ok"
                                            src={toAbsoluteUrl(
                                                "/media/icons/duotune/general/gen043.svg"
                                            )}
                                        />
                                    ) : (
                                        <SVG
                                            className="pulse-animation fail"
                                            src={toAbsoluteUrl(
                                                "/media/icons/duotune/general/gen040.svg"
                                            )}
                                        />
                                    )}
                                </>
                            ) : (
                                <OverlayTrigger overlay={tooltip}>
                                    {currentApiStatus.error === "NO_API_CREDENTIAL" ? (
                                        <SVG
                                            className="pulse-animation no-Credential"
                                            src={toAbsoluteUrl(
                                                "/media/icons/duotune/general/gen044.svg"
                                            )}
                                        />
                                    ) : (
                                        <SVG
                                            className="pulse-animation fail"
                                            src={toAbsoluteUrl(
                                                "/media/icons/duotune/general/gen040.svg"
                                            )}
                                        />
                                    )}
                                </OverlayTrigger>
                            )}
                            {api}
                        </span>
                        <span className="blanace">
                            {currentApiStatus.ok && (
                                <>
                                    {currentApiStatus.balance || currentApiStatus.balance === 0 ? (
                                        <>
                                            {typeof currentApiStatus.balance === "string" ? (
                                                <></>
                                            ) : (
                                                <>
                                                    Credit(s) :{" "}
                                                    {Math.floor(currentApiStatus.balance)}
                                                </>
                                            )}
                                        </>
                                    ) : (
                                        <>
                                            {formatMessage({
                                                id: `apiStatus.balance.unknown`,
                                            })}
                                        </>
                                    )}
                                </>
                            )}
                        </span>
                    </div>
                );
            })}
        </div>
    );
};

export default ApiStatusContainer;
